import { render, staticRenderFns } from "./billingForm.vue?vue&type=template&id=70d5b19b"
import script from "./billingForm.vue?vue&type=script&lang=js"
export * from "./billingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports